/* Cart savings animation (presentation only). */
(function () {
  'use strict';
  if (window.__riwiSavingsInit) return;
  window.__riwiSavingsInit = 1;

  var ROOT_SEL = '[data-riwi-cart][data-rc-context="page"]';
  var DESKTOP_MQ = '(min-width: 901px)';   /* = Breakpoint, ab dem .riwi-cart__layout 2-spaltig ist */
  var me = document.currentScript;
  var CSS_URL = me && me.getAttribute('data-rsa-css');

  var EASE = {
    OUT: 'cubic-bezier(.16,1,.3,1)', INOUT: 'cubic-bezier(.65,0,.35,1)', STD: 'cubic-bezier(.4,0,.2,1)',
    IN: 'cubic-bezier(.4,0,1,1)', DRAW: 'cubic-bezier(.5,0,.2,1)', RISE: 'cubic-bezier(.2,.65,.3,1)',
    FALL: 'cubic-bezier(.45,0,.8,.55)', HOLD: 'linear'
  };
  /* MOBIL (ruhig, jede Sektion einzeln bei Sichtbarkeit) — Werte 1:1 Referenz TIMING */
  var BASE = {
    START_DELAY: 600, GAP_NEAR: 150, GAP_CROSS: 300, GAP_BACK: 450, DWELL: 450, FAILSAFE: 25000,
    MARKER: { DRAW: 600, HOLD: 1100, FADE: 400 },
    GIFT: { BURST_AT: 420, HANDOFF: 1500 },
    STAR: { N: 10, STAGGER: 28, POP: 100, RISE: 460, ARC: 200, FALL: 340, GRAVITY: 26 },
    SWAP: { UP: 320, STRIKE: 340, READ_OLD: 240, OUT: 280, NEW_DELAY: 180, NEW_IN: 300,
            SETTLE: 150, READ_NEW: 400, BACK: 350, HANDOFF_BEFORE_END: 300 },
    SAVE: { AFTER_NEW: 0, IN: 500, RISE_PX: 6 },
    LINE_STAGGER: 350,
    SHINE: { DUR: 1000 },
    UPSELL: { UP: 260, DOWN: 300, RING: 240, HINT_AT: 650, HINT_HOLD: 400, HINT_FADE: 350 }
  };
  /* DESKTOP (>= 901 px, alles gleichzeitig sichtbar): COMPACT 1:1 Referenz, erste -> letzte Bewegung < 5 s */
  var COMPACT = {
    GAP_NEAR: 100, GAP_CROSS: 0, GAP_BACK: -100,
    MARKER: { DRAW: 520, HOLD: 700, FADE: 350 },
    GIFT: { BURST_AT: 380, HANDOFF: 680 },
    LINE_STAGGER: 120,
    STAR: { N: 10, STAGGER: 24, POP: 90, RISE: 400, ARC: 170, FALL: 320, GRAVITY: 26 },
    SWAP: { UP: 260, STRIKE: 280, READ_OLD: 160, OUT: 240, NEW_DELAY: 120, NEW_IN: 260,
            SETTLE: 120, READ_NEW: 320, BACK: 300, HANDOFF_BEFORE_END: 570 },
    SHINE: { DUR: 600 },
    UPSELL: { UP: 220, DOWN: 240, RING: 200, HINT_AT: 250, HINT_HOLD: 100, HINT_FADE: 200 }
  };

  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var current = null;      /* { stop } der laufenden bzw. geplanten Animation */
  var cssReady = null;     /* Promise: eigenes CSS geladen */

  function timing() {
    var t = {}, k;
    for (k in BASE) t[k] = BASE[k];
    if (mq(DESKTOP_MQ)) for (k in COMPACT) t[k] = COMPACT[k];
    return t;
  }

  function loadCss() {
    if (cssReady) return cssReady;
    cssReady = new Promise(function (ok, fail) {
      if (!CSS_URL) { fail(); return; }
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = CSS_URL;
      l.onload = ok; l.onerror = function () { cssReady = null; fail(); };
      document.head.appendChild(l);
    });
    return cssReady;
  }

  /* Vorab-Klassen weg = normaler Warenkorb (Streichpreise + "You save" sichtbar) */
  function disarm(root) {
    if (!root) return;
    root.classList.remove('rsa-armed');
    var pre = root.querySelectorAll('.rsa-pre');
    for (var i = 0; i < pre.length; i++) pre[i].classList.remove('rsa-pre');
  }

  /* Eine Animation je Element mit absoluten Zeitpunkten (ms); `e` = Easing bis zum naechsten Punkt */
  function track(el, start, points) {
    var end = points[points.length - 1].at, span = Math.max(end - start, 1);
    var kf = points.map(function (p) {
      var o = {}, k;
      for (k in p.k) o[k] = p.k[k];
      o.offset = (p.at - start) / span; o.easing = p.e || EASE.STD;
      return o;
    });
    return el.animate(kf, { delay: start, duration: span, fill: 'backwards', easing: 'linear' });
  }

  /* Waechst zur Seite mit mehr Platz und nur so weit, dass es im Kasten bleibt UND keinen
     benachbarten Text ueberdeckt (z. B. Label "Zwischensumme" links neben "CHF 328"). */
  function fit(el, wanted, skip, partner) {
    var box = el.closest('.riwi-cart__gift, .riwi-cart__line, .riwi-cart__summary, .riwi-cart__wrap') || document.body;
    var r = el.getBoundingClientRect(), b = box.getBoundingClientRect(), pad = 12, gap = 8;
    var roomL = r.left - b.left - pad, roomR = b.right - r.right - pad;
    var grow = r.height * (wanted - 1) / 2, top = r.top - grow, bot = r.bottom + grow;
    var leaves = box.querySelectorAll('*');
    for (var i = 0; i < leaves.length; i++) {
      var o = leaves[i], ctl = /^(INPUT|BUTTON|SELECT|IMG)$/.test(o.tagName);
      if (o === el || o.contains(el) || el.contains(o) || o.closest('[aria-hidden="true"]')) continue;
      if (skip && (o === skip || skip.contains(o) || o.contains(skip))) continue;   // Swap-Partner blasst ab, darf ueberdeckt werden
      var rowOnly = partner && (o === partner || partner.contains(o) || o.contains(partner));   // Partner steht nur NEBEN uns im Weg (gleiche Zeile), nicht darueber/darunter
      if (!ctl && ![].some.call(o.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); })) continue;   // nur Text-/Bedienelemente, keine Huellen
      var q = o.getBoundingClientRect();
      if (!ctl && document.createRange) { var rg = document.createRange(); rg.selectNodeContents(o); var tq = rg.getBoundingClientRect(); if (tq.width > 0) q = tq; }   // Textbreite, nicht Blockbreite
      if (rowOnly) { if (q.bottom <= r.top + 1 || q.top >= r.bottom - 1) continue; }   // ungeskalierte Zeile: uebereinander = kein Hindernis
      else if (q.bottom <= top || q.top >= bot) continue;
      if (q.width <= 1 || q.height <= 1) continue;   // unsichtbar (visually-hidden) / nicht auf gleicher Hoehe
      if (q.right <= r.left + 1) roomL = Math.min(roomL, r.left - q.right - gap);
      else if (q.left >= r.right - 1) roomR = Math.min(roomR, q.left - r.right - gap);
    }
    var right = roomL >= roomR, room = Math.max(right ? roomL : roomR, 0);
    return { origin: (right ? 'right' : 'left') + ' center', sc: Math.max(1, Math.min(wanted, 1 + room / Math.max(r.width, 1))) };
  }

  function run(root) {
    var T = timing(), DESK = mq(DESKTOP_MQ);
    var anims = [], cleanup = [], stopped = false, failT = 0;
    var T0 = document.timeline.currentTime;
    var add = function (a) { a.startTime = T0; anims.push(a); return a; };
    var STOP_ON = ['click', 'keydown'];

    function stop() {
      if (stopped) return;
      stopped = true;
      clearTimeout(failT);
      anims.forEach(function (a) { try { a.cancel(); } catch (e) {} });
      cleanup.forEach(function (fn) { try { fn(); } catch (e) {} });
      root.classList.remove('rsa-on');
      disarm(root);
      STOP_ON.forEach(function (e) { root.removeEventListener(e, stop, true); });
      document.removeEventListener('visibilitychange', onHide);
      if (current && current.stop === stop) current = null;
    }
    function onHide() { if (document.hidden) stop(); }
    current = { stop: stop };
    STOP_ON.forEach(function (e) { root.addEventListener(e, stop, { capture: true, passive: true }); });
    document.addEventListener('visibilitychange', onHide);
    root.classList.add('rsa-on');
    var PRE = [].slice.call(root.querySelectorAll('.riwi-cart__price-old:not(.riwi-cart__price-old--cmp), .riwi-cart__subtotal-was, [data-rc-save]'));
    PRE.forEach(function (el) { el.classList.add('rsa-pre'); });
    var reveal = function (el) { if (el) el.classList.remove('rsa-pre'); };
    var setOrigin = function (el, o) { el.style.transformOrigin = o; cleanup.push(function () { el.style.transformOrigin = ''; }); };
    var span = function (cls, host) {
      var s = document.createElement('span');
      s.className = cls; s.setAttribute('aria-hidden', 'true'); host.appendChild(s);
      cleanup.push(function () { s.remove(); });
      return s;
    };

    /* Preis-Swap: Alt-Preis gross -> roter Strich -> neuer Preis gruen gross -> beides zurueck.
       Der neue Preis (Endpreis) bleibt IMMER sichtbar, er wird nur betont. */
    function swap(oldEl, newEl, wanted, t) {
      if (!oldEl || !newEl) return { handoff: t, newAt: t, end: t };
      var S = T.SWAP, fo = fit(oldEl, wanted, null, newEl), fn = fit(newEl, wanted, oldEl);
      var cs = getComputedStyle(oldEl), grey = cs.color, deco = cs.textDecorationColor;
      setOrigin(oldEl, fo.origin); setOrigin(newEl, fn.origin);
      var line = span('rsa-line', oldEl);
      var tUp = t + S.UP, tStrike = tUp + S.STRIKE, tRead = tStrike + S.READ_OLD, tOut = tRead + S.OUT;
      var tNew0 = tRead + S.NEW_DELAY, tNew1 = tNew0 + S.NEW_IN, tSettle = tNew1 + S.SETTLE;
      var tBack0 = tSettle + S.READ_NEW, tEnd = tBack0 + S.BACK;
      var on = function (tr, op) { return { transform: tr, opacity: op, color: '#1B1D21', textDecorationColor: 'transparent' }; };
      reveal(oldEl);
      add(track(oldEl, t, [
        { at: t, e: EASE.OUT, k: on('scale(' + (fo.sc * .85).toFixed(3) + ')', 0) },
        { at: tUp, e: EASE.HOLD, k: on('scale(' + fo.sc + ')', 1) },
        { at: tRead, e: EASE.INOUT, k: on('scale(' + fo.sc + ')', 1) },
        { at: tOut, e: EASE.HOLD, k: on('scale(1)', .2) },
        { at: tBack0, e: EASE.INOUT, k: on('scale(1)', .2) },
        { at: tEnd, k: { transform: 'scale(1)', opacity: 1, color: grey, textDecorationColor: deco } }
      ]));
      add(track(line, t, [
        { at: t, e: EASE.HOLD, k: { transform: 'scaleX(0)', opacity: 1 } },
        { at: tUp, e: EASE.DRAW, k: { transform: 'scaleX(0)', opacity: 1 } },
        { at: tStrike, e: EASE.HOLD, k: { transform: 'scaleX(1)', opacity: 1 } },
        { at: tBack0 + 50, e: EASE.IN, k: { transform: 'scaleX(1)', opacity: 1 } },
        { at: tEnd, k: { transform: 'scaleX(1)', opacity: 0 } }
      ]));
      add(track(newEl, t, [
        { at: t, e: EASE.HOLD, k: { transform: 'scale(1)' } },
        { at: tNew0, e: EASE.OUT, k: { transform: 'scale(1)' } },
        { at: tNew1, e: EASE.INOUT, k: { transform: 'scale(' + (fn.sc * 1.04) + ')' } },
        { at: tSettle, e: EASE.HOLD, k: { transform: 'scale(' + fn.sc + ')' } },
        { at: tBack0, e: EASE.INOUT, k: { transform: 'scale(' + fn.sc + ')' } },
        { at: tEnd, k: { transform: 'scale(1)' } }
      ]));
      return { handoff: tEnd - S.HANDOFF_BEFORE_END, newAt: tSettle, end: tEnd };
    }

    /* Textmarker: gruene Flaeche zieht von links unter ein Element, steht, blendet aus.
       fitText: Flaeche nur so breit wie der Text (gemessen per Range, kein Layout-Eingriff). */
    function marker(el, s, a0, hold, fade, fitText) {
      var M = T.MARKER;
      hold = hold == null ? M.HOLD : hold; fade = fade == null ? M.FADE : fade;
      var tr = null, er = null;
      if (fitText && document.createRange) {      /* messen, BEVOR die Marker-Flaeche im Element liegt */
        var rg = document.createRange(); rg.selectNodeContents(el);
        tr = rg.getBoundingClientRect(); er = el.getBoundingClientRect();
      }
      el.classList.add('rsa-mk-host');
      cleanup.push(function () { el.classList.remove('rsa-mk-host'); });
      var mk = span('rsa-marker', el);
      if (tr && tr.width > 0) {
        mk.style.left = Math.round(tr.left - er.left - 8) + 'px';
        mk.style.right = Math.round(er.right - tr.right - 8) + 'px';
      }
      add(track(mk, s, [
        { at: s, e: EASE.HOLD, k: { transform: 'scaleX(0)', opacity: 1 } },
        { at: a0, e: EASE.DRAW, k: { transform: 'scaleX(0)', opacity: 1 } },
        { at: a0 + M.DRAW, e: EASE.HOLD, k: { transform: 'scaleX(1)', opacity: 1 } },
        { at: a0 + M.DRAW + hold, e: EASE.IN, k: { transform: 'scaleX(1)', opacity: 1 } },
        { at: a0 + M.DRAW + hold + fade, k: { transform: 'scaleX(1)', opacity: 0 } }
      ]));
      return a0 + M.DRAW;
    }

    /* Celebration: 10 Sterne/Punkte: Pop -> Steigen -> Scheitel -> Fallen (Schwerkraft) */
    function burst(host, s0) {
      var ST = T.STAR, N = ST.N;
      var txt = host.querySelector('.riwi-cart__gift-text') || host;
      var hr = host.getBoundingClientRect(), tr = txt.getBoundingClientRect();
      var ox = tr.left - hr.left + 8, oy = tr.top - hr.top + tr.height / 2;
      var colors = ['#FF8C02', '#FFC600', '#5CC95C', '#26ACE3', '#FF8C02', '#FFC600'];
      var tf = function (x, y, sc, r) { return 'translate(-50%,-50%) translate(' + x + 'px,' + y + 'px) scale(' + sc + ') rotate(' + r + 'deg)'; };
      for (var i = 0; i < N; i++) {
        var p = span('rsa-spark' + (i % 3 === 0 ? ' rsa-spark--dot' : ''), host);
        p.style.left = ox + 'px'; p.style.top = oy + 'px'; p.style.background = colors[i % colors.length];
        var ang = (-150 + (300 / (N - 1)) * i) * Math.PI / 180, dist = 30 + (i % 4) * 11;
        var dx = Math.cos(ang) * dist * 1.6, dy = Math.sin(ang) * dist;
        var rot = (i % 2 ? 1 : -1) * (90 + i * 20);
        var a0 = s0 + ((i * 7) % N) * ST.STAGGER, g = ST.GRAVITY * (0.8 + (i % 3) * 0.2);
        var t1 = a0 + ST.POP, t2 = t1 + ST.RISE, t3 = t2 + ST.ARC, t4 = t3 + ST.FALL;
        add(track(p, s0, [
          { at: s0, e: EASE.HOLD, k: { transform: tf(0, 0, .2, 0), opacity: 0 } },
          { at: a0, e: EASE.OUT, k: { transform: tf(0, 0, .2, 0), opacity: 0 } },
          { at: t1, e: EASE.RISE, k: { transform: tf(dx * .14, dy * .14, 1, rot * .15), opacity: 1 } },
          { at: t2, e: EASE.STD, k: { transform: tf(dx, dy, .95, rot * .8), opacity: 1 } },
          { at: t3, e: EASE.FALL, k: { transform: tf(dx * 1.06, dy + g * .3, .85, rot), opacity: .85 } },
          { at: t4, k: { transform: tf(dx * 1.12, dy + g, .5, rot * 1.15), opacity: 0 } }
        ]));
      }
    }

    function giftSec(s) {
      var gift = root.querySelector('.riwi-cart__gift.is-done');
      marker(gift, s, s);
      burst(gift, s + T.GIFT.BURST_AT);
      return s + T.GIFT.HANDOFF;
    }
    function lineSec(line) {
      var f = function (s) { return swap(line.querySelector('.riwi-cart__price-old:not(.riwi-cart__price-old--cmp)'), line.querySelector('.riwi-cart__price'), 2, s).handoff; };
      f.isLine = true;
      return f;
    }
    function summarySec(s) {
      var r = swap(root.querySelector('.riwi-cart__subtotal-was'), root.querySelector('.riwi-cart__subtotal-value'), 1.6, s);
      var tb = r.handoff, save = root.querySelector('[data-rc-save]');
      if (save) {
        var V = T.SAVE, tIn = r.newAt + V.AFTER_NEW;
        reveal(save);
        add(track(save, s, [
          { at: s, e: EASE.HOLD, k: { opacity: 0, transform: 'translateY(' + V.RISE_PX + 'px)' } },
          { at: tIn, e: EASE.OUT, k: { opacity: 0, transform: 'translateY(' + V.RISE_PX + 'px)' } },
          { at: tIn + V.IN, k: { opacity: 1, transform: 'translateY(0)' } }
        ]));
        if (!DESK) tb = Math.max(tb, tIn + V.IN);   /* Desktop: Schimmer laeuft parallel zum Einblenden */
      }
      return tb;
    }
    /* Checkout: NUR goldener Schimmer, ein Durchgang; der Button bewegt sich nie */
    function checkoutSec(s, btn) {
      var clip = span('rsa-shine-clip', btn), shine = document.createElement('span');
      shine.className = 'rsa-shine'; clip.appendChild(shine);
      var D = T.SHINE.DUR;
      add(track(shine, s, [
        { at: s, e: EASE.INOUT, k: { transform: 'translateX(-130%) skewX(-20deg)', opacity: 0 } },
        { at: s + D * .15, e: EASE.INOUT, k: { transform: 'translateX(-60%) skewX(-20deg)', opacity: 1 } },
        { at: s + D * .85, e: EASE.INOUT, k: { transform: 'translateX(290%) skewX(-20deg)', opacity: 1 } },
        { at: s + D, k: { transform: 'translateX(360%) skewX(-20deg)', opacity: 0 } }
      ]));
      return s + D;
    }
    function upsellSec(s) {
      var U = T.UPSELL, up = root.querySelector('[data-riwi-cart-hook="upsell"].riwi-cart__upsell');
      setOrigin(up, 'center center');
      add(track(up, s, [
        { at: s, e: EASE.OUT, k: { transform: 'scale(1)', boxShadow: '0 0 0 0 rgba(255,140,2,0)' } },
        { at: s + U.UP, e: EASE.INOUT, k: { transform: 'scale(1.03)', boxShadow: '0 0 0 0 rgba(255,140,2,.45)' } },
        { at: s + U.UP + U.DOWN, e: EASE.OUT, k: { transform: 'scale(1)', boxShadow: '0 0 0 10px rgba(255,140,2,.15)' } },
        { at: s + U.UP + U.DOWN + U.RING, k: { transform: 'scale(1)', boxShadow: '0 0 0 16px rgba(255,140,2,0)' } }
      ]));
      var hint = up.querySelector('.riwi-cart__upsell-hint');
      if (hint) return marker(hint, s, s + U.HINT_AT, U.HINT_HOLD, U.HINT_FADE, true);
      return s + U.UP + U.DOWN + U.RING;
    }

    /* Reihenfolge = Erzaehlung. el = muss komplett im Bild sein, bevor der Teil startet. */
    var secs = [], nLines = 0, handled = [];
    var gift = root.querySelector('.riwi-cart__gift.is-done');
    if (gift) secs.push({ el: gift, build: giftSec, gap: 0 });
    [].forEach.call(root.querySelectorAll('[data-rc-line]'), function (line) {
      if (!line.querySelector('.riwi-cart__price-old:not(.riwi-cart__price-old--cmp)') || !line.querySelector('.riwi-cart__price')) return;
      handled.push(line.querySelector('.riwi-cart__price-old:not(.riwi-cart__price-old--cmp)'));
      secs.push({ el: line.querySelector('.riwi-cart__line-money') || line, build: lineSec(line), gap: 0, stagger: nLines++ > 0 });
    });
    /* MOBIL: Sticky-Checkout-Leiste liegt per Portal AUSSERHALB root an <body> (riwi-cart-contents.js);
       schimmert nach der Preis-Zeile, nur wenn sie gerade sichtbar ist (.is-visible). */
    var sticky = document.querySelector('[data-rc-sticky-checkout].is-visible [data-rc-sticky-btn]');
    if (sticky && !DESK && !root.contains(sticky) && !sticky.disabled) {
      secs.push({ el: sticky, build: function (s) { return checkoutSec(s, sticky); }, gap: T.GAP_NEAR });
    }
    var sub = root.querySelector('.riwi-cart__subtotal');
    if (sub && sub.querySelector('.riwi-cart__subtotal-was')) {
      handled.push(sub.querySelector('.riwi-cart__subtotal-was'), root.querySelector('[data-rc-save]'));
      secs.push({ el: sub, build: summarySec, gap: T.GAP_CROSS });
    }
    var btn = root.querySelector('[data-rc-checkout]') || root.querySelector('.riwi-cart__checkout:not(.riwi-cart__update)');
    if (btn && !btn.disabled && btn.closest('[data-rc-sticky-checkout]') == null) {
      secs.push({ el: btn, build: function (s) { return checkoutSec(s, btn); }, gap: T.GAP_NEAR });
    }
    var up = root.querySelector('[data-riwi-cart-hook="upsell"].riwi-cart__upsell');
    if (up) secs.push({ el: up, build: upsellSec, gap: T.GAP_BACK });

    var pending = 0, observers = [];
    cleanup.push(function () { observers.forEach(function (o) { o.disconnect(); }); });
    function done() {
      if (pending) return;
      Promise.all(anims.map(function (a) { return a.finished; })).then(function () {
        if (!pending && anims.every(function (a) { return a.playState === 'finished'; })) stop();
      }, function () {});
    }
    var now = function () { return document.timeline.currentTime - T0; };
    /* Sichtbarer Bereich = Viewport minus feste Overlays: Sticky-Header oben, unten Sticky-Checkout-Leiste
       und Cookie-Banner. Ein Ziel INNERHALB eines Overlays (Sticky-Schimmer) rechnet es nicht gegen sich selbst. */
    var BOTTOM_OVERLAYS = '[data-rc-sticky-checkout].is-visible, #shopify-pc__banner';
    var insets = function (el) {
      var top = 0, bot = 0, i, n, r, cs;
      n = document.querySelectorAll('.shopify-section-header-sticky:not(.shopify-section-header-hidden)');
      for (i = 0; i < n.length; i++) {
        r = n[i].getBoundingClientRect(); cs = getComputedStyle(n[i]);
        if (r.height > 0 && r.top <= 1 && r.bottom > 0 && (cs.position === 'sticky' || cs.position === 'fixed')) top = Math.max(top, r.bottom);
      }
      n = document.querySelectorAll(BOTTOM_OVERLAYS);
      for (i = 0; i < n.length; i++) {
        if (n[i].contains(el)) continue;
        r = n[i].getBoundingClientRect(); cs = getComputedStyle(n[i]);
        if (cs.display === 'none' || cs.visibility === 'hidden' || r.height <= 0 || r.top >= innerHeight || r.bottom < innerHeight - 4) continue;
        bot = Math.max(bot, innerHeight - r.top);
      }
      return { top: top, bot: bot };
    };
    var inView = function (el) {
      var r = el.getBoundingClientRect(), v = insets(el);
      return r.top >= v.top - 4 && r.bottom <= innerHeight - v.bot + 4 && r.height > 0;
    };
    var cursor = 0, lastStart = 0, prevLine = false;
    var place = function (sec, earliest) {
      var st = sec.stagger && prevLine ? Math.max(lastStart + T.LINE_STAGGER, earliest) : Math.max(cursor + sec.gap, earliest);
      lastStart = st; prevLine = sec.build.isLine === true;
      cursor = Math.max(cursor, sec.build(st));
    };
    secs.forEach(function (sec) {
      if (inView(sec.el) || !('IntersectionObserver' in window)) { place(sec, 0); return; }
      sec.stagger = false;                       /* spaet ins Bild gescrollt -> normal hinterher */
      pending++;
      var timer = 0, v = insets(sec.el), rm = '-' + Math.round(v.top) + 'px 0px -' + Math.round(v.bot) + 'px 0px';
      var o = new IntersectionObserver(function (es) {
        if (stopped) return;
        if (!es.some(function (e) { return e.isIntersecting; })) { clearTimeout(timer); timer = 0; return; }
        if (timer) return;
        timer = setTimeout(arm, T.DWELL);
      }, { threshold: 0.95, rootMargin: rm });
      function arm() {
        timer = 0;
        if (stopped) return;
        if (!inView(sec.el)) { timer = setTimeout(arm, 250); return; }   /* verdeckt: weiter warten, bis frei oder weggescrollt */
        o.disconnect(); pending--;
        place(sec, now() + 60);
        done();
      }
      cleanup.push(function () { clearTimeout(timer); });
      o.observe(sec.el); observers.push(o);
    });
    /* Vorab versteckt, aber ohne eigene Sektion (z. B. Zeile ohne Preis-Element): sofort sichtbar */
    PRE.forEach(function (el) { if (handled.indexOf(el) < 0) reveal(el); });
    root.classList.remove('rsa-armed');
    done();
    failT = setTimeout(stop, T.FAILSAFE);
  }

  /* Startet eine vom Guard scharf geschaltete Wurzel: CSS laden, Schriften abwarten, Ruhe
     (START_DELAY). Wer in der Zeit klickt/tippt, sieht keine Animation (sofort normaler Warenkorb). */
  function schedule(root) {
    if (!root || !root.classList.contains('rsa-armed') || !root.animate || !document.timeline) { disarm(root); return; }
    var key = window.__rsaSig ? window.__rsaSig(root) : '';
    try { sessionStorage.setItem(key, '1'); } catch (e) {}
    var t = 0, off = false;
    function cancel() {
      if (off) return;
      off = true; clearTimeout(t);
      ['click', 'keydown'].forEach(function (e) { root.removeEventListener(e, cancel, true); });
      if (current && current.stop === cancel) current = null;
      disarm(root);
    }
    current = { stop: cancel };
    ['click', 'keydown'].forEach(function (e) { root.addEventListener(e, cancel, { capture: true, passive: true }); });
    var fonts = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    Promise.all([loadCss(), fonts]).then(function () {
      if (off) return;
      t = setTimeout(function () {
        if (off || !root.isConnected || !root.classList.contains('rsa-armed') || document.hidden) { cancel(); return; }
        off = true;
        ['click', 'keydown'].forEach(function (e) { root.removeEventListener(e, cancel, true); });
        clearTimeout(window.__rsaFailsafe);
        window.__rsaStarted = 1;
        try { run(root); } catch (e) { if (current) current.stop(); disarm(root); }
      }, timing().START_DELAY);
    }, cancel);
  }

  function stopCurrent() { if (current) current.stop(); }

  try {
    schedule(document.querySelector(ROOT_SEL + '.rsa-armed'));
    /* Re-Render (Menge/Entfernen/Code, riwi-cart-contents.js refreshFrom -> replaceWith):
       laufende Animation sofort beenden; Neustart NUR bei neuer Rabatt-Signatur (Guard entscheidet). */
    document.addEventListener('riwi-cart:updated', function (e) {
      try {
        stopCurrent();
        var next = e && e.detail && e.detail.container;
        if (next && next.matches && next.matches(ROOT_SEL) && window.__rsaArm && window.__rsaArm(next)) schedule(next);
      } catch (err) {}
    });
    /* Zurueck aus dem Checkout (bfcache): nie halb animiert stehen lassen */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      stopCurrent();
      disarm(document.querySelector(ROOT_SEL));
    });
  } catch (e) { /* Darstellung darf den Warenkorb nie stoeren */ }
})();
